module.exports = __webpack_public_path__ + "static/memoexpress-a5a963bc157361f1d5eb2e5f19e25df9.png";